module.exports = __webpack_public_path__ + "img/left_arrow.2abc0686.svg";